module.exports = __webpack_public_path__ + "static/img/video-symbol.e914028e.png";